import { render, staticRenderFns } from "./modalCrearOC.vue?vue&type=template&id=7958e9d5&"
import script from "./modalCrearOC.vue?vue&type=script&lang=ts&"
export * from "./modalCrearOC.vue?vue&type=script&lang=ts&"
import style0 from "./modalCrearOC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7958e9d5', component.options)
    } else {
      api.reload('7958e9d5', component.options)
    }
    module.hot.accept("./modalCrearOC.vue?vue&type=template&id=7958e9d5&", function () {
      api.rerender('7958e9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesCompra/modalCrearOC.vue"
export default component.exports